<template>
  <v-container>
    <v-row class="my-2 search-row">
      <v-autocomplete
          v-model="searchCameras"
          :items="cameras"
          class="pa-0 ma-0 search-bar-map"
          item-text="type"
          item-value="value"
          @change="searchCamera()"
          :label="$t('enterOrSelectCamera')"
          v-if="isStatistics === true"
          :no-data-text="$t('noData')"
      >
      </v-autocomplete>
    </v-row>
    
    <v-tooltip bottom v-model="show" class="alert-no-location" v-if="isStatistics===true">
      <template v-slot:activator="{ attrs }">
        <v-btn @click="show = !show" icon class="notification-icon" v-bind="attrs">
          <v-icon class="icon-alert">mdi-alert-circle</v-icon>
        </v-btn>
      </template>
      <div v-if="camerasNoLocation.length > 0">
      <span>{{$t('camerasNoLocation')}} </span><br>
      <ul v-for="(cam,index) in camerasNoLocation" :key="index">
        <li>{{cam}}</li>
      </ul>
      </div>
      <div v-else>
        {{$t('noNotifications')}}
      </div>
    </v-tooltip>

    <div class="map" id="mapid" v-if="getPoints().length>0"/>
      
    <v-row align="center" class="map"
    justify="center" v-else>
    
      <v-col class="text-center"><span class="no-info">{{$t('noGeographicInformation')}}.</span></v-col>
    </v-row>    
    
  </v-container>
</template>

<script>
import Leaflet from 'leaflet'
import "leaflet.heat";
export default {
  props:{
    markers:{
      type: Array, 
      default: ()=>{ return []}
    },
    isStatistics: {
      type: Boolean,
      default: ()=>{return false}
    },
    cameraSelected: {
      type: String,
      default: ()=>{return ''}
    }
  },
  data(){
    return {
      mapMarkers: [],
      searchCameras: '',
      cameras: [],
      markersStatistics: [],
      maxDownloads: 0,
      camerasNoLocation: [],
      show: false
    }
  },
  watch: {
    cameraSelected: function (newVal, oldVal) {
      if (newVal !== oldVal && this.cameraSelected !== '' && this.isStatistics) {
        this.searchCameras=this.cameraSelected
        this.searchCamera()
      }
    },
  },

  mounted(){
    if(this.isStatistics){
      this.getHeatMap()
      
    } 
    setTimeout(()=>{
      if(this.getPoints().length>0){
          this.loadMap()
      }
      if(this.cameraSelected!=='' && this.isStatistics){
        this.searchCameras=this.cameraSelected
        this.searchCamera()        
      }
      if(this.isStatistics){
      this.markersStatistics.forEach(m => {
        if(m.geoLocation !== null){
          this.cameras.push(m.cameraName)
        }
      })
    } 
    }, 600)
  },
  computed: {
    start: {
        get(){
            return this.$store.getters.getStartDate
        },
        set(value){
            return this.$store.commit('setStartDate', value)
        }
    },
    rangeDates: {
        get(){
            return this.$store.getters.getRange
        },
        set(value){
        return this.$store.commit('setRange', value)
      }

    },
    searchView: {
        get(){
            return this.$store.getters.getSearch
        },
        set(value){
            return this.$store.commit('setSearch', value)
        }
    },
  },
  methods:{
    getHeatMap(){
      this.camerasNoLocation = []
        this.$extractions.getHeatMap(this.searchView,this.start,this.rangeDates).then(res=>{
            this.markersStatistics = res.data
            let max = 0
            res.data.forEach(c => {
              if(c.downloads > max){
                max = c.downloads
              }
              if(c.geoLocation === null){
                this.camerasNoLocation.push(c.cameraName)
              }
            })
            if(this.camerasNoLocation.length !== 0){
              //this.show = true
              let icon = document.getElementsByClassName("notification-icon")[0]
              icon.classList.add("icon-notification")
            }
            this.maxDownloads = max
        }).catch(e=>{
            console.log('Error: ', e)
        }) 
    },
    loadMap(){
      
      const hereTileUrl = `https://1.base.maps.ls.hereapi.com/maptile/2.1/maptile/newest/normal.day/{z}/{x}/{y}/512/png8?apiKey=4jl6FFgvraT6TyzL5-mWwBGdjrizKZmghELnm5jCmo4`;
      const map = Leaflet.map('mapid', {
        center: [-34.6083, -58.3712],
        zoom: 8,
        layers: [Leaflet.tileLayer(hereTileUrl)],
        zoomControl:this.isStatistics ? true : false,
      });

      //map.attributionControl.addAttribution('&copy; HERE 2019');
      
      if(this.markers.length>0){
        var extractionsMarkers = this.getPoints()
        var mMarkers = []
        
        extractionsMarkers.forEach(extMarker=> {
          if(this.isStatistics){
            mMarkers.push(Leaflet.marker([extMarker.location[0],extMarker.location[1]]).bindPopup("<b>"+extMarker.name + "</b><br>" +
            this.$t('numberOfExtractions') + ': ' + extMarker.downloads).addTo(map))
          } else{
            mMarkers.push(Leaflet.marker([extMarker.location[0],extMarker.location[1]]).bindPopup("<b>"+extMarker.name).addTo(map))
          }
          if(this.isStatistics === true){
            Leaflet.heatLayer([
              [extMarker.location[0],extMarker.location[1], extMarker.downloadsHeat],
            ], {radius: 30,minOpacity: 0.1, blur:7, gradient: {0.4: '#ddf00a', 0.6: '#edae0e', 1: '#ed2a0c'}}).addTo(map);
          }
        })
        this.mapMarkers = mMarkers
        var bounds = new Leaflet.LatLngBounds(extractionsMarkers.map(em=>[em.location]));
        
        map.fitBounds(bounds)
      }        
     },
    searchCamera(){
     this.mapMarkers.forEach(m => {
        if(m._popup._content.includes(this.searchCameras) && this.isStatistics === true){
          m.openPopup();
        } else{
          m.closePopup();
        }
      })
    },
    getPoints(){
      var locations = []
      if(!this.isStatistics){
        this.markers.forEach(extraction=>{
          
          if (extraction.geoLocation &&(locations.findIndex(loc=> loc.name === extraction.cameraName)===-1)){
            locations.push({location:[extraction.geoLocation[0], extraction.geoLocation[1]], name: extraction.cameraName})
          }
        })
      }else{
        this.markersStatistics.forEach(extraction=>{
          /*if(extraction.geoLocation !== null){
            this.cameras.push(extraction.cameraName)
          }*/
          if (extraction.geoLocation &&(locations.findIndex(loc=> loc.name === extraction.cameraName)===-1)){
            let downloads = extraction.downloads / this.maxDownloads
            locations.push({location:[extraction.geoLocation[0], extraction.geoLocation[1]], name: extraction.cameraName, downloads: extraction.downloads, downloadsHeat: downloads.toFixed(1)})
          }
        })
      }
      return locations
    }
  }
  
}
</script>
<style >
.leaflet-control-attribution{
  display: none!important;
}
.notification-icon{
  position: absolute!important;
  right: 40px!important;
  top: 150px!important;
  z-index: 100!important;
}
.map {
  height:180px;  
}
.no-info{
  color: #91919c;
}
.mySelector{
  background-color: #fff!important;
  padding: 5px!important;
  border-radius: 10px!important;
}
.search-bar-map .v-menu__content{
  right: 10px!important;
  max-width: 25%!important;
}
.search-bar-map{
  max-width: 25%!important;
}
.search-row{
  justify-content: flex-end!important;
}
.icon-notification{
  color: #d9c007!important;
}
@media (max-width: 2700px) {
    .notification-icon{
      right: 400px!important;
    }
}
@media (max-width: 2400px) {
    .notification-icon{
      right: 300px!important;
    }
}
@media (max-width: 2000px) {
    .notification-icon{
      right: 200px!important;
    }
}
@media (max-width: 1700px) {
    .notification-icon{
      right: 50px!important;
    }
}
@media (max-width: 960px) {
    .search-row {
      margin-right: 200px!important;
    }
}
@media (max-width: 930px) {
    .search-row {
      margin-right: 260px!important;
    }
}
@media (max-width: 860px) {
    .search-row {
      margin-right: 310px!important;
    }
}
@media (max-width: 800px) {
    .search-row {
      margin-right: 380px!important;
    }
}
@media (max-width: 730px) {
    .search-row {
      justify-content: flex-start!important;
      margin-left: 30px!important;
    }
}

</style>